<template>
  <div>
    <router-link
      v-if="!external"
      :to="url"
      @click.native="$_clickInternal"
      class="app-sidebar__nav__link"
    >
      <OptimizerIcon
        :type="icon"
        :class="icon"
      /> {{ name }}
      <b-badge
        v-if="badge"
        :variant="badge.variant"
      >
        {{ badge.text }}
      </b-badge>
    </router-link>
    <a
      v-else-if="external"
      :href="url"
      class="app-sidebar__nav__link"
      target="_blank"
      @click.prevent="$_click"
    >
      <OptimizerIcon
        :type="icon"
        :class="icon"
      /> {{ name }}
      <b-badge
        v-if="badge"
        :variant="badge.variant"
      >{{ badge.text }}</b-badge>
    </a>
  </div>
</template>

<script>
import OptimizerIcon from '@sh/components/Utils/OptimizerIcon.ts.vue';
import EventBus from '@sh/services/eventBus';
import session from '@sh/services/session';
import router from '@sh/services/router';


export default {
  name: 'SidebarNavLink',
  components: {
    OptimizerIcon,
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    badge: {
      type: [Object],
      default: () => null,
    },
    external: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    $_click(event) {
      window.open(event.target.href, event.target.target);
    },
    $_clickInternal() {
      EventBus.trigger('click-sidebar-menu-item');
      this.redirectToAccountWizard();
    },
    redirectToAccountWizard() {
      const route = router.app._route.name;
      const routes = ['Rules', 'GotoCampaignCreator', 'Campaigns', 'TrafficSources', 'Trackers', 'Dashboard'];
      const user = session.getUser();

      if (user?.trafficSources !== undefined && !user.trafficSources.length && routes.includes(route)) {
        router.push({ name: 'AccountWizard', params: { noIntegrations: true } });
      }
    },
  },
};
</script>
